import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { generateUID } from 'ah-common-lib/src/helpers/uuid';
import { useTheme } from 'ah-theme';


export default /*#__PURE__*/_defineComponent({
  __name: 'NeedHelpButton',
  setup(__props) {

const uid = ref(generateUID(6));
const theme = useTheme();

const helpLink = computed(() => theme.val?.helpURL);
const helpEmail = computed(() => theme.val?.helpEmail);

const goToHelpLink = () => {
  window.open(helpLink.value, '_blank');
};

return { __sfc: true,uid, theme, helpLink, helpEmail, goToHelpLink }
}

})